import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_TASKS_REQUEST = 'FETCH_TASKS_REQUEST';
export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
export const FETCH_TASKS_FAILURE = 'FETCH_TASKS_FAILURE';
export const FETCH_TASK_OWNERS_REQUEST = 'FETCH_TASK_OWNERS_REQUEST';
export const FETCH_TASK_OWNERS_SUCCESS = 'FETCH_TASK_OWNERS_SUCCESS';
export const FETCH_TASK_OWNERS_FAILURE = 'FETCH_TASK_OWNERS_FAILURE';
export const FETCH_DOS_TASKS_REQUEST = 'FETCH_DOS_TASKS_REQUEST';
export const FETCH_DOS_TASKS_SUCCESS = 'FETCH_DOS_TASKS_SUCCESS';
export const FETCH_DOS_TASKS_FAILURE = 'FETCH_DOS_TASKS_FAILURE';
export const FETCH_TASK_TYPES_REQUEST = 'FETCH_TASK_TYPES_REQUEST';
export const FETCH_TASK_TYPES_SUCCESS = 'FETCH_TASK_TYPES_SUCCESS';
export const FETCH_TASK_TYPES_FAILURE = 'FETCH_TASK_TYPES_FAILURE';
export const FETCH_TASK_CENTRES_REQUEST = 'FETCH_TASK_CENTRES_REQUEST';
export const FETCH_TASK_CENTRES_SUCCESS = 'FETCH_TASK_CENTRES_SUCCESS';
export const FETCH_TASK_CENTRES_FAILURE = 'FETCH_TASK_CENTRES_FAILURE';
export const CANCEL_TASK_REQUEST = 'CANCEL_TASK_REQUEST';
export const CANCEL_TASK_SUCCESS = 'CANCEL_TASK_SUCCESS';
export const CANCEL_TASK_FAILURE = 'CANCEL_TASK_FAILURE';

export function fetchTasks(filterParams) {
  return (dispatch) => {
    const url = buildUrl('/tasks/my-tasks?' +
        `pageSize=${filterParams.pageSize}&` +
        `pageNumber=${filterParams.pageNumber}&` +
        `sortBy=${filterParams.sortBy}&` +
        `sortType=${filterParams.sortType}&` +
        `isAllTasks=${filterParams.taskFilter}`);
    const method = 'GET';

    return dispatch(fetchTasksRequest()).payload
      .then((response) => dispatch(fetchTasksSuccess(response)))
      .catch((error) => dispatch(fetchTasksFailure(error)));

    function fetchTasksRequest() {
      return ApiCall.createAction({
        type: FETCH_TASKS_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchTasksSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_TASKS_SUCCESS,
        payload: response,
        url,
        method,
      });
    }

    function fetchTasksFailure(error) {
      return ApiCall.createAction({
        type: FETCH_TASKS_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}

export function fetchDosTasks(filterParams) {
  return (dispatch) => {
    const url = buildUrl('/tasks/dos-tasks' +
        `/centres/${filterParams.taskCentre}` +
        `/task-owners/${filterParams.taskOwner}?` +
        `pageSize=${filterParams.pageSize}&` +
        `pageNumber=${filterParams.pageNumber}&` +
        `sortBy=${filterParams.sortBy}&` +
        `sortType=${filterParams.sortType}&` +
        `isAllTasks=${filterParams.taskFilter}&` +
        `taskTypeCode=${filterParams.taskSubject}`);
    const method = 'GET';
    return dispatch(fetchDosTaskRequest()).payload
      .then((response) => dispatch(fetchDosTaskSuccess(response)))
      .catch((error) => dispatch(fetchDosTaskFailure(error)));

    function fetchDosTaskRequest() {
      return ApiCall.createAction({
        type: FETCH_DOS_TASKS_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchDosTaskSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_DOS_TASKS_SUCCESS,
        payload: response,
        url,
        method,
      });
    }

    function fetchDosTaskFailure(error) {
      return ApiCall.createAction({
        type: FETCH_DOS_TASKS_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}

export const taskOwnersUrl = buildUrl('/tasks/dos-tasks/task-owners');

export function fetchTaskOwnersIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: taskOwnersUrl })) {
      return false;
    }

    return dispatch(fetchTaskOwners());
  };
}

export function fetchTaskOwners() {
  return (dispatch) => {
    const url = taskOwnersUrl;
    const method = 'GET';

    return dispatch(fetchTaskOwnersRequest()).payload
      .then((response) => dispatch(fetchTaskOwnersSuccess(response)))
      .catch((error) => dispatch(fetchTaskOwnersFailure(error)));

    function fetchTaskOwnersRequest() {
      return ApiCall.createAction({
        type: FETCH_TASK_OWNERS_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchTaskOwnersSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_TASK_OWNERS_SUCCESS,
        payload: response,
        url,
        method,
      });
    }

    function fetchTaskOwnersFailure(error) {
      return ApiCall.createAction({
        type: FETCH_TASKS_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}


const taskCentresUrl = buildUrl('/tasks/dos-tasks/centres');

export function fetchTaskCentresIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: taskCentresUrl })) {
      return false;
    }

    return dispatch(fetchTaskCentres());
  };
}

export function fetchTaskCentres() {
  return (dispatch) => {
    const method = 'GET';
    const url = taskCentresUrl;

    return dispatch(fetchTaskCentresRequest()).payload
      .then((response) => dispatch(fetchTaskCentresSuccess(response)))
      .catch((error) => dispatch(fetchTaskCentresFailure(error)));

    function fetchTaskCentresRequest() {
      return ApiCall.createAction({
        type: FETCH_TASK_CENTRES_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchTaskCentresSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_TASK_CENTRES_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function fetchTaskCentresFailure(error) {
      return ApiCall.createAction({
        type: FETCH_TASK_CENTRES_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const taskTypesUrl = buildUrl('/tasks/types');

export function fetchTaskTypesIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: taskTypesUrl })) {
      return false;
    }

    return dispatch(fetchTaskTypes());
  };
}

export function fetchTaskTypes() {
  return (dispatch) => {
    const method = 'GET';
    const url = taskTypesUrl;

    return dispatch(fetchTaskTypesRequest()).payload
      .then((response) => dispatch(fetchTaskTypesSuccess(response)))
      .catch((error) => dispatch(fetchTaskTypesFailure(error)));

    function fetchTaskTypesRequest() {
      return ApiCall.createAction({
        type: FETCH_TASK_TYPES_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchTaskTypesSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_TASK_TYPES_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function fetchTaskTypesFailure(error) {
      return ApiCall.createAction({
        type: FETCH_TASK_TYPES_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function cancelTask(taskId) {
  return (dispatch) => {
    const url = buildUrl(`/tasks/${taskId}/cancel`);
    const method = 'PUT';
    return dispatch(cancelTaskRequest()).payload
      .then((response) => dispatch(cancelTaskSuccess(response)))
      .catch((error) => dispatch(cancelTaskFailure(error)));

    function cancelTaskRequest() {
      return ApiCall.createAction({
        type: CANCEL_TASK_REQUEST,
        payload: fetch(url, { method }),
        method,
        url,
      });
    }

    function cancelTaskSuccess(response) {
      return ApiCall.createAction({
        type: CANCEL_TASK_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function cancelTaskFailure(error) {
      return ApiCall.createAction({
        type: CANCEL_TASK_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Tasks/actions.js